<script setup>
import {useUsersStore} from "@/stores"
import socialRmLogo from "@/assets/social-rm.svg"

const props = defineProps({
  isDialogVisible: {
    type: Boolean,
    required: true
  }
})
const emit = defineEmits([
  'update:isDialogVisible',
  'update:reservation',
  'confirm',
  'cancel'
])
const usersStore = useUsersStore()
let myUser = null;
({ myUser } = storeToRefs(usersStore))


const linkCopied = ref(false)

const updateModelValue = val => {
  emit('update:isDialogVisible', val)
}
const onClose = () => {
  emit('close', true)
  emit('update:isDialogVisible', false)
}


const webShareApiSupported = computed(() => {
  return navigator.share
})

const link = computed(() => {
  return `${window.location.origin}/m/${myUser.value?.profileId}`
})

const shareLink = () => {
  if (navigator.share) {
    navigator.share({
      title: 'My Profile on RM',
      url: link.value,
    })
      .then(() => console.log('Successful share'))
      .catch(error => console.log('Error sharing', error))
  }
}

const copyToClipboard = async () => {
  try {
    await navigator.clipboard.writeText(link.value)
    linkCopied.value = true
    console.log('Text copied to clipboard')
  } catch (err) {
    console.log('Failed to copy text: ', err)
  }
}
</script>

<template>
  <!-- 👉 Confirm Dialog -->
  <VDialog
    :model-value="props.isDialogVisible"
    fullscreen
    @update:model-value="updateModelValue"
  >
    <VCard class="px-2 py-2 pb-0">
      <Profile
        class="mt-14 pa-2"
        :member="myUser"
        :public-view="true"
      />

      <div
        style="display: flex; align-items: center; align-self: center;"
        class="mt-2"
      >
        <img
          :src="socialRmLogo"
          height="20"
          class="mr-1"
        >
        <span>Your Profile</span><br>
      </div>

      <div class="align-self-center">
        <b>reserverm.com/m/{{ myUser?.profileId }}</b>
      </div>

      <div class="mt-3 align-self-center">
        private profile view that restaurants review on your requests
      </div>

      <div class="mt-3 align-self-center">
        <div
          v-if="webShareApiSupported"
          class="custom-button"
          role="button"
          tabindex="0"
          @click="shareLink"
        >
          <VIcon size="24">
            mdi-share
          </VIcon>
          <span>Share Profile</span>
        </div>
        <div
          class="custom-button ml-4"
          role="button"
          tabindex="0"
          @click="copyToClipboard"
        >
          <VIcon size="24">
            icon-park-outline:copy-link
          </VIcon>
          <span v-if="linkCopied">Link Copied</span>
          <span v-else>Copy Link</span>
        </div>
      </div>

      <div class="mt-3 align-self-center">
        add/use for bookings on other apps
      </div>

      <VBtn
        icon="$close"
        size="large"
        variant="text"
        color="secondary"
        class="dialog-close-btn"
        @click="onClose"
      >
        <VIcon>mdi-close</VIcon>
      </VBtn>
    </VCard>
  </VDialog>
</template>

<style scoped>
.custom-button {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 16px;
  gap: 4px; /* Adjusts the space between the icon and the text */
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;
  /* Add more styles as needed to match your design requirements */
  /* For example, to mimic a Vuetify button: */
  background-color: #FFFFFF; /* Button background */
  color: rgb(var(--v-theme-primary)); /* Text and icon color */
  border: 1px solid #E0E0E0; /* Border color */
  border-radius: 7px; /* Border radius */
  text-align: center;
}

.custom-button:hover {
  background-color: #F5F5F5; /* Lighter shade on hover */
}

.custom-button:focus {
  outline: none;
  /* Style for focus state, for accessibility */
  box-shadow: 0 0 0 2px rgba(25, 118, 210, 0.3);
}

.custom-button > .v-icon {
  --v-icon-size: 24px; /* Control the icon size */
}

.dialog-close-btn {
  position: fixed;
  right: 6px;
  top: 6px;
}
</style>
